// removed by extract-text-webpack-plugin
module.exports = {"container":"_1uM2RPZAySzox34sfEk7L0","icon":"l9i4gVvz76lD_Fj8GDDRP","title":"_3N5JF2cMwdptAnXGKB-3Wb","form":"_1jwGb8cEn3kfkSwbfT5cIp","button":"_3DqNHsNPEcbxOFoZobVvG7","code":"_13L5WN_JtsLrqMRzhbEA56"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/styles.css
// module id = 2997
// module chunks = 0